import { Severity } from '../enums';

export interface PentestScanResultSummary {
  id: string;
  status: Severity;
}

export namespace PentestScanResultSummary {
  export function mapFromApiValue(pentestScanResult: { id: string; status: string }): PentestScanResultSummary {
    const { status, ...restOfPentestScanResult } = pentestScanResult;
    return {
      ...restOfPentestScanResult,
      status: Severity.mapFromApiValue(status),
    };
  }
}
